(function() {
  function hideEmptyPromos() {
    document.querySelectorAll('.promo-productlist').forEach(function(li) {
      if (li.dataset.jbChecked) return;
      var hasImg = li.querySelector('.defer-image img, img');
      var hasVideo = li.querySelector('video, viewport-media');
      if (!hasImg && !hasVideo) {
        li.style.display = 'none';
      }
      li.dataset.jbChecked = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideEmptyPromos);
  } else {
    hideEmptyPromos();
  }
  new MutationObserver(hideEmptyPromos).observe(document.body, { childList: true, subtree: true });
})();
